<template>
  <div class="text-center"><UInput
    @input="search"
    icon="i-heroicons-magnifying-glass-20-solid"
    size="xl"
    color="blue"
    :trailing="false"
    class=""
    placeholder="Search skills by name..."
  /></div>
</template>

<script setup>
import { useSkillStore } from "../store";
const store = useSkillStore();

const search = async ({ target }) => {
  const query = target.value;
  store.setQuery(query);
};
</script>
